import styled from 'styled-components';

export const Svg = styled.svg`
  display: inline-block;
  vertical-align: middle;
`;
